export const unitToLiters = (unit) => {
    const matrix = {
        ml: 0.001,
        cl: 0.01,
        dl: 0.1,
        l: 1,
    };

    try {
        return matrix[unit];
    }
    catch (e) {
        console.warn("Could not convert unit to liters", e);
        return 0;
    }
};

export const calculateCogs = (unit, amount, price, unitCostPrice, unitAmountInLiters) => {
    if (!unit || !amount || !price) return 0;
    let cogs = 0;

    const measureableUnitsOfMeasure = ["pcs", "btl", "can", "unit", "glass", "bag"]; // TODO: Get from API

    if (measureableUnitsOfMeasure.includes(unit)) {
        cogs = (unitCostPrice / price) * amount * 100;
    } else {

        const unitInLiters = unitToLiters(unit);
        const salesPricePerLiter = price / (amount * unitInLiters);

        const buyPricePerLiter =
            unitCostPrice / unitAmountInLiters;

        cogs = (buyPricePerLiter / salesPricePerLiter) * 100;
    }

    return parseFloat(cogs).toFixed(2);
};

export const calculateTotalCost = (unit, amount, unitCostPrice, unitAmountInLiters) => {
    if (!unit || !amount || !unitCostPrice) return 0;
    let totalCost = 0;

    const measureableUnitsOfMeasure = ["pcs", "btl", "can", "unit", "glass", "bag"]; // TODO: Get from API


    if (measureableUnitsOfMeasure.includes(unit)) {
        totalCost = unitCostPrice * amount;
    } else {
        const unitInLiters = unitToLiters(unit);
        totalCost = unitCostPrice * (amount * unitInLiters);
    }

    return parseFloat(totalCost).toFixed(2);
}